/*
 * @Author: ma.rongqin
 * @Date: 2016.7.29
 * @LastEditTime : 2019-12-21 11:23:22
 * @LastEditors  : cc
 * @FilePath: \xjmediacloud\app\resourceCenter\classifiedResource\weibo\weibo.js
 * @Description:
 */
'use strict';
angular.module('resCenNewWeiboModule', ['resCenWeiboLeftModule', 'resWeiboRouter']).controller('resCenNewWeiboCtrl', [
    '$scope',
    '$state',
    '$element',
    '$stateParams',
    '$q',
    '$timeout',
    'trsHttpService',
    'initComDataService',
    'resourceCenterService',
    'resCtrModalService',
    'modalDialog',
    'trsspliceString',
    'globleParamsSet',
    'storageListenerService',
    'trsPrintService',
    'messagePublishService',
    function(
        $scope,
        $state,
        $element,
        $stateParams,
        $q,
        $timeout,
        trsHttpService,
        initComDataService,
        resourceCenterService,
        resCtrModalService,
        modalDialog,
        trsspliceString,
        globleParamsSet,
        storageListenerService,
        trsPrintService,
        messagePublishService
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化状态
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            // 初始化分页参数
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: globleParamsSet.setResourceCenterPageSize,
            };
            // 初始化数据
            $scope.data = {
                casDataArea: [], // 地区的级联数组
                themeType: {}, // 主题参数
                keyType: {}, // 搜索词的类型
                selectedArray: [], // 当前的选择项
                currPage: 1, // 当前页数
                docType: {
                    data: [],
                    curValue: {},
                }, // 稿件类型
                timeType: {}, // 时间类型
            };
            $scope.basicParams = {
                channelName: 'wb',
                typeName: $stateParams.typename,
                nodeId: $stateParams.nodeid,
            };
            // 请求列表的参数,有一些写死的参数
            $scope.params = {
                typeid: 'zyzx',
                serviceid: 'wb',
                modelId: 'findFromNavigation',
                pageSize: $scope.page.PAGESIZE,
                pageNum: $scope.page.CURRPAGE,
                keyword: '',
                fcode: '',
            };
            var paramsArray = $stateParams.param_data.split('&');
            for (var i in paramsArray) {
                var attribute = paramsArray[i].toLowerCase();
                $scope.params[attribute] = $stateParams[attribute];
            }
            // 检索词参数
            $scope.keyword = {
                searchType: '', // 查询类型
                keywords: '', // 关键词
                time: '', // 时间范围
                area: '', // 地域
                zyzxfield: '', // 主题
                isOriginal: '', // 是否原创
                isHead: '', // 是否头版
                isRead: '', // 是否10w+
                menuscriptType: '', // 稿件类型
                medianame: $state.params.medianame,
            };
            $scope.status = {
                channelType: $stateParams.channeltype, // 栏目类型
                isSzbPage: false, // 是否为数字报版面布局
                screenWrapSelected: false, // 是否显示更多筛选
                singleGraph: false, // 是否为单图模式
                displayPreview: false,
                isrepetite: false,
                hasphoto: false, // 是否显示图集
                isOnly: false, // 是否进行排重
                isOriginal: false, // 是否原创
                isRead: false, // 是否10w+
            };
        }

        /**
         * [initData description]数据初始化
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            listenStorage();
            // 检索字段
            $scope.data.keyType = {
                data: initComDataService.searchBigdataType(),
                curValue: initComDataService.searchBigdataType()[0],
            };
            getDraftType();
            getThemeData().then(function() {
                requestData();
            });
            refreshList();
        }

        /**
         * [refreshList description]刷新列表
         * @return  {[undefined]}  [return description]
         */
        function refreshList() {
            messagePublishService.subscribe('changclassifiedList', function(event, data) {
                $scope.keyword.account = data.sitename;
                $scope.params.fcode = '';
                delete $scope.keyword.medianame;
                requestData();
            },$scope);
        }

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenResource(function() {
                requestData();
                storageListenerService.removeListener('resource');
            }, $scope);
        }

        /**
         * [showSelectedArea description：数据地域信息的级联菜单获取数据]
         * @param   {[type]}  node  [node description]选中的节点
         * @return  {[type]}        [return description]
         */
        $scope.showSelectedArea = function(node) {
            var defer = $q.defer();
            resourceCenterService.getArea(node).then(function(data) {
                defer.resolve(data);
            });
            return defer.promise;
        };

        /**
         * [getThemeData description：获取主题数据]
         */
        function getThemeData() {
            var defer = $q.defer();
            var themeParams = {
                serviceid: 'navigation',
                typeid: 'zyzx',
                modelid: 'base',
                parentId: '-1',
                level: '2',
                excludeId: '-1',
                containParent: false,
                channelName: 'wb',
                typeName: 'zyzxfield',
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), themeParams, 'post').then(function(themeData) {
                $scope.data.themeType = {
                    data: [
                        {
                            dictName: '所有主题',
                            id: '',
                        },
                    ].concat(themeData),
                    curValue: {
                        dictName: '所有主题',
                        id: '',
                    },
                };
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [getDraftType description：获取稿件类型]
         */
        function getDraftType() {
            var defer = $q.defer();
            var params = {
                typeid: 'zyzx',
                modelid: 'getSearchMenu',
                serviceid: 'wb',
                channelName: 'wb',
                typeName: 'zyzxfield',
                nodeId: 'zyzxfield_001001',
                menuName: 'menuscriptType',
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                $scope.data.docType.data = new Array();
                for (var i = 0; i < data.content[0].length; i++) {
                    $scope.data.docType.data[i] = {
                        name: data.content[0][i].ENNAME,
                        value: data.content[0][i].CNNAME,
                    };
                }
                if ($scope.data.docType.data.length >= 1) {
                    $scope.data.docType.curValue = $scope.data.docType.data[0];
                }
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [getFilterVal description：获取过滤信息]
         * @param {Object} key 参数类型
         * @param {Object} val 需要的过滤数据
         */

        $scope.getFilterVal = function(key, val) {
            switch (key) {
                case 'area':
                    // 获取ID
                    $scope.keyword.area = val[0][val[0].length - 1].id;
                    break;
                case 'time':
                    // 获取开始和结束时间
                    var st = $scope.data.untildate.replace(new RegExp('-', 'gm'), '/');
                    var et = $scope.data.fromdate.replace(new RegExp('-', 'gm'), '/');
                    if (st == '' && et == '') {
                        $scope.keyword.time = '';
                    } else {
                        $scope.keyword.time = st + ',' + et;
                    }
                    if ($scope.status.isrepetite && st == '') {
                        return;
                    }
                    break;
                case 'zyzxfield':
                    // 获取主题
                    $scope.keyword.zyzxfield = val;
                    break;
                case 'doctype':
                    // 获取文件类型
                    $scope.keyword.menuscriptType = val;
                    break;
                case 'keyword':
                    // 获取文件类型
                    $scope.keyword.keywords = val;
                    $scope.keyword.searchType = $scope.data.keyType.curValue.value;
                    break;
            }
            if ($scope.data.fromdate == '') {
                $scope.status.isrepetite = true;
            } else {
                $scope.status.isrepetite = false;
            }
            clearPageData();
            // 刷新列表
            requestData();
        };

        /**
         * [clearPageData 清楚列表数据]
         */
        function clearPageData() {
            $scope.params.pageNum = 1;
            $scope.data.itemstemporary = [];
            $scope.data.selectedArray = [];
            $scope.status.unloadover = true;
        }

        /**
         * [requestData description：获取列表数据]
         */
        function requestData() {
            $scope.keyword.isOriginal = $scope.status.isOriginal ? '1' : '';
            $scope.keyword.isRead = $scope.status.isRead ? '1' : '';
            $scope.params.keyword = JSON.stringify($scope.keyword);
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, 'post').then(function(data) {
                $scope.data.headers = data.summary_info.hybaseField; // 表头信息
                $scope.page = data.summary_info; // 分页信息
                $scope.basicParams.indexName = data.summary_info.indexName;
                $scope.data.selectedArray = []; // 清空之前的选择数据
                // 循环数组 给数据加上序号
                for (var i = 0; i < data.content.length; i++) {
                    data.content[i].NUMBER = (($scope.page.CURRPAGE - 1) * $scope.page.PAGESIZE + i + 1).toString();
                }
                // 判断是否是图集稿件
                if ($scope.status.Only) {
                    $scope.status.itemsPaiChong = listPaiChong(data.content, 'DOCTITLE', 'ZB_SOURCE_SITE'); // 经过排重的数据
                    $scope.data.itemstemporary = $scope.status.itemsPaiChong;
                } else {
                    $scope.data.itemstemporary = data.content;
                    initOperFlag();
                }
                storageListenerService.previewPageTurningStorage($scope.data.itemstemporary, 'ZB_GUID', 'resourceDetail');
                getImgList(data.content);
            });
        }

        /**
         * 请求图片数据
         * @param {Object} list
         */
        function getImgList(list) {
            var docIds = trsspliceString.spliceString(list, 'ZB_GUID', ',');
            if (docIds) {
                var params = {
                    typeid: 'zyzx',
                    modelid: 'getImgList',
                    serviceid: $scope.basicParams.channelName,
                    channelName: $scope.basicParams.channelName,
                    guids: docIds,
                };
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                    if (data.result == 'success') {
                        var temp = data.content[0];
                        var arr = angular.copy($scope.data.itemstemporary);
                        for (var i = 0; i < arr.length; i++) {
                            arr[i].imgurl = [];
                            if (temp[arr[i].ZB_GUID]) {
                                for (var j = 0; j < temp[arr[i].ZB_GUID].IMAGEURLS.length; j++) {
                                    arr[i].imgurl[j] = temp[arr[i].ZB_GUID].IMAGEURLS[j].urlM;
                                }
                            }
                        }
                        $scope.data.items = [];
                        $timeout(function() {
                            $scope.data.items = arr;
                        }, 0);
                    }
                });
            } else {
                $scope.data.items = [];
            }
        }

        /**
         * [determineSelected description] 判断是否有选中稿件
         */
        function determineSelected() {
            if (!$scope.data.selectedArray.length) {
                modalDialog.alertType('请先选择稿件！', '', 'warning', false, '');
                return false;
            } else {
                return true;
            }
        }

        /**
         * [openTakeDraftModal description]取稿
         */
        $scope.openTakeDraftModal = function() {
            if (!determineSelected()) {
                return;
            }
            var params = {
                methodname: 'fetch',
                channelName: 'wb',
                indexName: $scope.basicParams.indexName,
                nodeId: $stateParams.nodeid,
                serviceid: 'mlf_bigdataexchange',
                guid: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
            };
            //              params = angular.extend(params, $scope.basicParams);
            var isOnlyOne = !($scope.data.selectedArray.length > 1);
            var modalInstance = resCtrModalService.fullTakeDraft(params, isOnlyOne, $scope.data.selectedArray);
            modalInstance.result.then(
                function(data) {
                    takeDraftDownloadImgs(data).then(function() {
                        initOperFlag();
                    });
                },
                function() {
                    initOperFlag();
                }
            );
        };

        /**
         * [takeDraftDownloadImgs description]  图片正在下载中情况，跳转至下载弹窗
         * @param  {[type]} data [description]
         * @return {[type]}      [description]
         */
        function takeDraftDownloadImgs(data) {
            var deferred = $q.defer();
            var needDownloadImg = false;
            for (var i = 0; i < data.REPORTS.length; i++) {
                if (data.REPORTS[i].PICERROR == 1) {
                    needDownloadImg = true;
                    break;
                }
            }
            if (needDownloadImg) {
                resCtrModalService.takeDraftDownloadImgs(data, function(res) {
                    deferred.resolve();
                });
            } else {
                deferred.resolve();
            }
            return deferred.promise;
        }

        /**
         * [CreationAxis description]个人素材
         */
        $scope.CreationAxis = function() {
            if (!determineSelected()) {
                return;
            }
            var params = {
                typeid: 'zyzx',
                serviceid: 'mlf_bigdataexchange',
                channelName: 'wb',
                typeName: $stateParams.typename,
                nodeId: $stateParams.nodeid,
                indexName: $scope.basicParams.indexName,
                guid: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                modelid: 'creation',
            };
            params.guid = trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ',');
            resourceCenterService.setBigDataCreation(params).then(function(data) {
                modalDialog.alertType('添加成功', '', 'success', false, function() {
                    $scope.data.selectedArray = [];
                });
            });
        };

        /**
         * [collect description]收藏
         */
        $scope.collect = function() {
            if (!determineSelected()) {
                return;
            }
            var params = {
                typeid: 'zyzx',
                //                  methodname: 'batchPersonalMaterial',
                serviceid: 'mlf_bigdataexchange',
                channelName: 'wb',
                typeName: $stateParams.typename,
                nodeId: $stateParams.nodeid,
                indexName: $scope.basicParams.indexName,
                methodname: 'collect',
                guid: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('收藏成功!', '', 'success', false, function() {
                    $scope.data.selectedArray = [];
                });
            });
        };

        /**
         * [openReserveDraftModal description]预留
         */
        $scope.openReserveDraftModal = function() {
            if (!determineSelected()) {
                return;
            }
            var resCtrModalServiceModal = resCtrModalService.reserveDraft($scope.data.selectedArray);
            resCtrModalServiceModal.result.then(function(result) {
                delete result.items;
                var params = {
                    typeid: 'zyzx',
                    // methodname: 'batchPersonalMaterial',
                    serviceid: 'mlf_bigdataexchange',
                    channelName: 'wb',
                    typeName: $stateParams.typename,
                    nodeId: $stateParams.nodeid,
                    indexName: $scope.basicParams.indexName,
                    guid: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                    methodname: 'delay',
                    //                      SourceName: "资源中心-网站-%E6%94%BF%E6%B2%BB"
                };
                params = angular.extend(params, result);
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                    function(data) {
                        modalDialog.alertType('预留成功!', '', 'success', false, function() {
                            initOperFlag();
                        });
                    },
                    function() {
                        /* initOperFlag();
                        $scope.data.selectedArray = [];*/
                    }
                );
            });
        };

        /**
         * [printbtn description]打印
         */
        $scope.printbtn = function() {
            if (!determineSelected()) {
                return;
            }
            var params = {
                serviceid: 'wb',
                modelid: 'detailData',
                guid: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                channelName: 'wb',
                typeid: 'zyzx',
                indexName: $scope.basicParams.indexName,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                trsPrintService.trsPrintBigData(data);
            });
        };

        /**
         * [export description]导出
         */
        $scope.export = function() {
            if (!determineSelected()) {
                return;
            }
            var params = {
                serviceid: 'mlf_exportword',
                methodname: 'exportBigDataDocs',
                GUIDS: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                CHANNELNAMES: 'wb',
                indexName: $scope.basicParams.indexName,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                window.open('/wcm/app/file/read_file.jsp?FileName=' + data);
            });
        };

        /**
         * [fullTextSearch description;全文检索]
         * @param  {[type]} ev [description:按下空格也能提交]
         */
        $scope.fullTextSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
            }
        };

        /**
         * [initOperFlag description] 初始化取签见撤重
         */
        function initOperFlag() {
            var docIds = trsspliceString.spliceString($scope.data.itemstemporary, 'ZB_GUID', ',');
            if (docIds) {
                var params = {
                    methodname: 'queryFlag',
                    serviceid: 'mlf_bigdataexchange',
                    guids: docIds,
                };
                params = angular.extend(params, $scope.basicParams);
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    $scope.data.operFlags = [];
                    var temp = data;
                    for (var i in temp) {
                        if (angular.isDefined(data[i]) && data[i].OPERFLAG.indexOf('1') > -1) {
                            $scope.data.operFlags = $scope.data.operFlags.concat(data[i]);
                        }
                    }
                });
            }
            $scope.data.selectedArray = [];
        }

        /**
         * [showOperFlag description] 显示取签见撤重标志
         * @param  {[type]} guid      [description]
         * @param  {[type]} flagIndex [description]
         * @return {[type]}           [description]
         */
        $scope.showOperFlag = function(guid, flagIndex) {
            var temp = queryItemBYGUID(guid);
            if (!!temp) {
                return queryItemBYGUID(guid).OPERFLAG.substr(flagIndex, 1) == '1';
            } else {
                return false;
            }
        };

        /**
         * [queryItemBYGUID description] 根据guid获取在WCM内的取签见撤重的二进制数
         * @param  {[type]} guid [description]
         * @return {[type]}      [description]
         */
        function queryItemBYGUID(guid) {
            for (var i in $scope.data.operFlags) {
                if (guid == $scope.data.operFlags[i].GUID) {
                    return $scope.data.operFlags[i];
                }
            }
        }

        /**
         * [selectAll description:全选]
         */
        /* $scope.selectAll = function() {
                $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
            };*/

        /**
         * [selectDoc 单选]
         * @param  {[type]} item [description：单个对象]
         */
        $scope.selectDoc = function(item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice(index, 1);
            }
        };

        /**
         * [viewBigDataInfo description] 取签见撤重 点击弹出
         * @param  {[type]} ChnlDocId  [description] 稿件id
         * @param  {[type]} showRepeat [description] 类型
         * @return {[type]}            [description]
         */
        $scope.viewBigDataInfo = function(ChnlDocId, showRepeat, showClick) {
            var operFlags = queryItemBYGUID(ChnlDocId).OPERFLAG;
            var infoModal = resCtrModalService.bigDataInfoModal(ChnlDocId, showRepeat, showClick, operFlags);
        };

        /**
         * [pageChanged description]分页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.params.pageNum = $scope.page.CURRPAGE;
            $scope.data.currPage = $scope.page.CURRPAGE;
            requestData();
            resourceCenterService.scrollTop($element);
        };
        $scope.selectPageNum = function() {
            $scope.params.pageNum = $scope.page.CURRPAGE;
            $scope.data.currPage = $scope.page.CURRPAGE;
            $scope.params.pageSize = $scope.page.PAGESIZE;
            requestData();
            resourceCenterService.scrollTop($element);
        };
        $scope.jumpToPage = function() {
            $scope.params.pageNum = $scope.data.currPage;
            $scope.page.CURRPAGE = $scope.data.currPage;
            requestData();
            resourceCenterService.scrollTop($element);
        };

        /**
         * [quickPreview description] 快速预览模式
         * @return {[type]} [description]
         */
        $scope.quickPreview = function() {
            $state.go('front.networksource.classifiedresource.website.quickpreview', $stateParams);
        };

        /**
         * 要求 同时判断key,name,两个参数同时存在才进行排重
         * key,name,为要排重的属性
         * [listPaiChong 去除重复数组]
         * @param  {[type]} data  [Array]
         * @param  {[type]} key   [String]
         * @param  {[type]} name   [String]
         * @return {[type]}       [Array]
         */
        function listPaiChong(data, key, name) {
            var List = [
                {
                    DOCTITLE: '',
                    ZB_SOURCE_SITE: '',
                },
            ]; // 去重后的数据
            for (var i = 0; i < data.length; i++) {
                for (var k = 0; k < List.length; k++) {
                    // 遍历保存后的List数据，用indexOf查找同时存在的key,name当条数据
                    if (List[k][key].indexOf(data[i][key]) > -1 && List[k][name].indexOf(data[i][name]) > -1) {
                        // 处理序号后跳出循环
                        var number = List[k].NUMBER;
                        List[k] = data[i]; // 把最早的重复数据 赋值给LIST的数据
                        List[k].NUMBER = number + ',' + List[k].NUMBER;
                        break;
                    } else {
                        // 在key,name不等的情况下，只保存一条数据，防止重复加载push数据
                        if (k == List.length - 1) {
                            List.push(data[i]);
                            break;
                        }
                    }
                }
            }
            // 删除初始化的第一条数据
            List.splice(0, 1);
            // 处理List连续序号为“-”连接
            for (var j = 0; j < List.length; j++) {
                List[j].NUMBER = ListPaiChongChuLi(List[j].NUMBER);
            }
            return List;
        }

        /**
         * [ListPaiChongChuLi 处理数据排重连续数据为“-”连接]
         * @param {[type]} item [数据处理的字符串]
         * @return {[type]}       [string]
         */
        function ListPaiChongChuLi(item) {
            // 拆分字符串为数组
            var testArray = item.split(',');
            // 如果item传入为 "1" 返回数据为 "0-1"
            if (testArray.length === 1) {
                return item;
            }
            var resultArray = ['0'];
            for (var i = 0; i < testArray.length; i++) {
                var index = parseInt(testArray[i]);
                var resultLastIndex = resultArray[resultArray.length - 1];
                if (resultLastIndex.indexOf('-') > 0) {
                    var resultLastIndexArray = resultLastIndex.split('-');
                    resultLastIndex = resultLastIndexArray[resultLastIndexArray.length - 1];
                    if (index - parseInt(resultLastIndex) === 1) {
                        resultArray[resultArray.length - 1] = resultLastIndexArray[0] + '-' + index;
                    } else {
                        resultArray.push(index.toString());
                    }
                } else {
                    if (index - parseInt(resultLastIndex) === 1) {
                        resultArray[resultArray.length - 1] = resultLastIndex + '-' + index;
                    } else {
                        resultArray.push(index.toString());
                    }
                }
            }
            if (resultArray[0].indexOf('0-') === 0) {
                var headArray = resultArray[0].split('-');
                for (var i = 0; i < testArray.length - 1; i++) {
                    if (parseInt(testArray[i]) > parseInt(headArray[0]) && parseInt(testArray[i]) <= parseInt(headArray[1])) {
                        resultArray[0] = parseInt(testArray[i]) === parseInt(headArray[1]) ? headArray[1] : testArray[i] + '-' + headArray[1];
                        break;
                    }
                }
            } else {
                resultArray.splice(0, 1);
            }
            return resultArray.join(',');
        }

        /**
         * [isOnly URL排重]
         * @return {Boolean} [description]
         */
        $scope.isOnly = function() {
            $scope.status.Only = !$scope.status.Only;
            requestData();
        };

        /**
         * [openUrl description] 微博-查看原微博
         * @param  {[type]} url [description]
         * @return {[type]}     [description]
         */
        $scope.openUrl = function(url) {
            // var reg = /http[s]{0,1}:\/\//;
            // var resultUrl = reg.test(url) ? url : 'http://' + url;
            window.open(url);
        };

        /**
         * [goDetail description] 微博-打开详情页
         * @param  {[type]} item [description] 当前数据
         * @return {[type]}      [description]
         */
        $scope.goDetail = function(item) {
            var detail = $state.href('resourcedetail', {
                guid: item.ZB_GUID,
                indexname: $scope.basicParams.indexName,
                channel: $scope.basicParams.channelName,
            });
            window.open(detail);
        };

        /**
         * [openPageForSearch description] 打开高级检索新页面
         * @return {[date]} [description]
         */
        $scope.openPageForSearch = function() {
            var url = $state.href('resadvancedsearch');
            window.open(url, '_blank');
        };
    },
]);
